import { observeElementInView } from "../vendor/inview-observer";
// eslint-disable-next-line import/no-unresolved -- swiper/bundle is a valid package export; resolver doesn't follow package.json "exports"
import Swiper from "swiper/bundle";

const initTestimonials = (section) => {
	if (section.dataset.initialized === "true") {
		return;
	}

	const root = section.querySelector(".testimonials__swiper");
	const pager = section.querySelector(".testimonials__pager");

	if (!root) {
		return;
	}

	const slides = root.querySelectorAll(".swiper-slide");

	if (!slides.length) {
		return;
	}

	new Swiper(root, {
		slidesPerView: 1,
		spaceBetween: 24,
		speed: 600,
		watchOverflow: true,
		grabCursor: slides.length > 1,
		autoHeight: true,
		pagination:
			pager && slides.length > 1
				? {
						el: pager,
						clickable: true,
					}
				: undefined,
	});

	section.dataset.initialized = "true";
};

const boot = () => {
	document.querySelectorAll(".testimonials").forEach((section) => {
		observeElementInView(section, () => initTestimonials(section));
	});
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
